// ./das-application-steps/index.js
import React from 'react';

import StepContent1 from "./StepContent1";
import StepContent2 from "./StepContent2";
import StepContent3 from "./StepContent3";
import StepContent4 from "./StepContent4";
import StepContent5 from "./StepContent5";
import StepContent6 from "./StepContent6";

const getSteps = () => [
  {
    label: "Step 1: Personal Information",
    content: <StepContent1 />,
  },
  {
    label: "Step 2: Career & Post-Secondary Plans",
    content: <StepContent2 />,
  },
  {
    label: "Step 3: Evidence Of Achievement",
    content: <StepContent3 />,
  },
  {
    label: "Step 4: Courses & Extracurricular & Awards",
    content: <StepContent4 />,
  },
  {
    label: "Step 5: References",
    content: <StepContent5 />,
  },
  {
    label: "Step 6: Review & Submit",
    content: <StepContent6 />,
  },
];

export { getSteps };
